
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar,Pagination,FormGroup,Form} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
// import ReactPaginate from 'react-paginate';
import { Box } from 'reactjs-admin-lte'
import PODocStore from '../../stores/PODocStore'
// import SupplierEditModal from './SupplierEditModal'
import SWTCustomerEditModal from 'view/workdoc/SWTCustomerEditModal'
import ReportPurchaseOrderPage from '../report/ReportPurchaseOrderPage'
import withSizes from 'react-sizes';
import ReportMobileTable from '../report/ReportMobileTable'

const ROW_PER_PAGE = 10
class SupplierPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      account_edit_view:'short_view',      
      loading:false,
      showEdit:false,
      showHistory:false,
      // curPage:0,
      // pageCount:0,
      query:'',
      catOptions:[],
      tableData:[],
      dataPerPage:[],
      totalPage:1,
      activePage:1,
      shop_id:''
    }
  }

  componentDidMount(){
    this.loadSupplierList('','')
  }

  loadSupplierList(query,pageNo){
    this.setState({loading:true})
    PODocStore.loadSupplierList(query,pageNo,(result) => {
      let totalPage = 1
      totalPage = result.data.length/ROW_PER_PAGE
      this.setState({tableData:result.data,loading:false,dataPerPage:this.getPagination(result.data,1),totalPage:Math.ceil(totalPage),
        account_edit_view:result.account_edit_view,catOptions:result.category})
    })
  }

  getPagination(data,activePage) {
    let page_data = []
    let start = 0
    let count = 0
    if (activePage!==1)
      start = (activePage*ROW_PER_PAGE) - ROW_PER_PAGE

    data.forEach(function(item,index) {
      if (index>=start&&count<ROW_PER_PAGE){
        page_data.push(item)
        count++
      }
    })
    return page_data
  }

  onHide(){

  }

  onTextChange(e){
    
    let query = e.target.value

    if(typeof query!=='undefined' && query.length>2){
      this.loadSupplierList(query);
    }
    this.setState({query:query})
    
  }

  onNewClick(){
    let {catOptions} = this.state
    this.refs.wageitemedit.loadItemcode(null,catOptions)
    this.setState({showEdit:true})
  }

  onEditClick(item){
    let {catOptions} = this.state
    this.refs.wageitemedit.loadItemcode(item,catOptions)
    this.setState({showEdit:true})
  }

  onHistoryClick(item){
    // this.refs.customerHist.loadData(2561,'09','00','shop_id',item.shop_id,0,13,()=>{})
    this.setState({showHistory:true,shop_id:item.shop_id})
  }

  onRowClick(item){
    
    //this.props.onSelect(item)
    if(typeof this.props.onSelectItem!=='undefined')
      this.props.onSelectItem(item)
    else{
      this.onEditClick(item)
    }      
  }

  onClearClick(){
    this.setState({query:'',curPage:0,catSelect:null})
    this.loadSupplierList('')
  }

  onAfterSubmit(postData){
    this.onClearClick()
  }

  onSearchAfterSubmit(){

  }

  onAfterDelete(){
    this.onClearClick()
  }

  onSaveClick(postData,completeFunc){
    PODocStore.saveSupplier(postData,completeFunc,()=>{

    })
  }

  onDelClick(item,completeFunc){
    //console.log('postData',postData)
    PODocStore.delSupplier(item.shop_id,completeFunc,(error)=>{

    })
  }

  onPageChange(page){
    // console.log('Change page to ',page)
    let {query} = this.state
    
    this.loadSupplierList(query,page.selected)

    this.setState({curPage:page.selected})
  }

  renderSearch(){
    let {query,catSelect,catOptions} = this.state
    let {showNew,isMobile} = this.props
    if(typeof showNew=='undefined'){
      showNew = true
    }
    return (
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup controlId="formInlineEmail" style={{width:(isMobile?'100%':'30%')}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)} style={{width:'100%'}} />
        </FormGroup>{' '}
        <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>{' '}
        <Button style={{display:showNew?'':'none'}} bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มรายการร้านสั่งซื้อ</Button>
      </Form>
    )
  }

  renderRowData(){
    // let showEditColumn = (this.props.onSelectItem!==undefined)
    let {dataPerPage,activePage} = this.state
    let number = (activePage*10)-10
    return dataPerPage.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'  onClick={this.onRowClick.bind(this,item)}>{number+1+index}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.shop_category}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.address}</td>        
        <td  onClick={this.onRowClick.bind(this,item)} >{item.tel}</td>
        <td className='text-center'  onClick={this.onRowClick.bind(this,item)} >{item.credit_day}</td>
        <td className='text-center' >
          <ButtonToolbar>
            <Button onClick={this.onHistoryClick.bind(this,item)}>ประวัติ</Button>
            <Button onClick={this.onEditClick.bind(this,item)}>แก้ไข</Button>
          </ButtonToolbar>
        </td>
      </tr>
    )) 
  }

  renderSearchResult(){
    // let showEditColumn = (this.props.onSelectItem!==undefined)
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th style={{width:'50px'}}>#ID</th>
            <th style={{width:'300px'}}>ชื่อร้านสั่งซื้อ</th>
            <th style={{width:'150px'}}>ประเภท</th>
            <th>ที่อยู่</th>            
            <th style={{width:'150px'}}>เบอร์โทร</th>
            <th style={{width:'150px'}}>เครดิตการค้า</th>
            <th style={{width:'150px'}}>ดูประวัติ/แก้ไข</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        
      </table>
    )
  }

  onPageSelect(e) {
    let {tableData} = this.state
    this.setState({activePage:e,dataPerPage:this.getPagination(tableData,e)})
  }

  renderPaging(){
    // let {pageCount} = this.state
    // if(pageCount>0){
    //   return (
    //     <div className="commentBox">        
    //       <ReactPaginate  
    //                     previousLabel={"ก่อนหน้า"}
    //                     nextLabel={"ถัดไป"}
    //                     breakLabel={<a href="">...</a>}
    //                     breakClassName={"break-me"}
    //                     pageCount={this.state.pageCount}
    //                     marginPagesDisplayed={2}
    //                     pageRangeDisplayed={2}
    //                     onPageChange={this.onPageChange.bind(this)}
    //                     containerClassName={"pagination pull-right"}
    //                     subContainerClassName={"pages pagination"}
    //                     activeClassName={"active"} />
    //     </div>
    //   ); 
    // } else{
    //   return (<div/>)
    // }
    return(
          <div className="text-right">
            <Pagination
              prev="ก่อนหน้า"
              next="ถัดไป"
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.onPageSelect.bind(this)}
            />
          </div>
    )      
  }

  renderHistoryModal() {
    return(
        <Modal show={this.state.showHistory} onHide={()=>this.setState({showHistory:false})} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>ประวัติร้านค้า</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ReportPurchaseOrderPage
              show={this.state.showHistory}
              mode={'stock'}
              shop_id={this.state.shop_id}
              ref={'customerHist'}
              loadOnShow={true}
              showNewButton={false}
              showCategorySelect={false}
              showTextSearch={false}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={()=>this.setState({showHistory:false})}><FontAwesome name='close' />&nbsp;ปิด</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  onRowWorkClick(item,items) {
    this.onRowClick(items)
  }

  renderMobileTable(){
    let {dataPerPage} = this.state
    let fieldMap = {title:'name',amount:'tel',sub_title:'address',date:'',status:'',sub_status:''}
    return(
      <div>
        <ReportMobileTable
          itemlist={dataPerPage}
          fieldMap={fieldMap}
          keyIndex={'shop_id'}
          numberFormat={false}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  render(){
    let {isMobile} = this.props
    let {loading,showEdit,catOptions} = this.state
    return (
      <div>
          <Box loading={loading}>            
            <Box.Body>
              {this.renderSearch()}
              {isMobile?this.renderMobileTable():this.renderSearchResult()}
              {this.renderPaging()}
            </Box.Body>
          </Box>    
          <SWTCustomerEditModal  ref={'wageitemedit'} show={showEdit} 
          editTitle={'ร้านค้า'}
          accountEditView={this.state.account_edit_view}
          catOptions={catOptions} 
          showProvince={false}
          isCustomer={false}
          onSaveClick={this.onSaveClick.bind(this)}
          onDelClick={this.onDelClick.bind(this)}
          onAfterDelete={this.onAfterDelete.bind(this)}
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onSearchAfterSubmit={this.onSearchAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showEdit:false})}}/>

          {/* wageitemedit2 */}
          {/* <SupplierEditModal  ref={'wageitemedit'} show={showEdit} 
          accountEditView={this.state.account_edit_view}
          catOptions={catOptions} 
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showEdit:false})}}/> */}

          {this.renderHistoryModal()}          
      </div>
    )
  }
}

SupplierPage.defaultProps = {
  
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default SupplierPage = withSizes(mapSizesToProps)(SupplierPage);





// WEBPACK FOOTER //
// ./src/view/po/SupplierPage.js